import { DamenkomLogoIcon } from "@assets/icons";
import { useStoreInfoCtx } from "@contexts/StoreInfoContext";
import { getSizedImage, ImageSize } from "@utils/get-sized-image";
import { Link } from "react-router";

export function Header() {
  const { storeInfo } = useStoreInfoCtx();

  return (
    <header className="mx-auto flex w-full max-w-2xl items-start px-4 pt-4 md:max-w-3xl lg:max-w-6xl">
      <div className="flex items-center gap-2">
        <Link
          to="https://damenkom.com/new-home-page"
          target="_blank"
          rel="noopener noreferrer"
          className="w-fit">
          {storeInfo.logo ? (
            <img
              src={getSizedImage(storeInfo.logo, ImageSize.small)}
              alt={storeInfo.name || "Store Logo"}
              className="h-[60px]"
            />
          ) : (
            <DamenkomLogoIcon className="h-[60px]" />
          )}
        </Link>
        {storeInfo.name && (
          <p className="text-sm font-bold">{storeInfo.name}</p>
        )}
      </div>
    </header>
  );
}
